export default __webpack_public_path__ + "static/media/sticker-2.8fd480de.png";